module.exports = __webpack_public_path__ + "static/media/quote1.ed6b034a.jpeg";